/**
 * Formatting for the facts a KPI dashboard states about itself (DOP-479).
 *
 * Separate from `formatKpiValue.ts`, which formats the numbers IN the grid:
 * this is about the workflow's definition — the window it extracts over — and
 * the two have no reason to move together.
 */

/** "2025-01-01" → "Jan 2025". An unparseable date is shown as it arrived. */
function formatMonth(date: string | null): string | null {
	if (!date) return null;
	const parsed = new Date(`${date}T00:00:00`);
	if (Number.isNaN(parsed.getTime())) return date;
	return parsed.toLocaleDateString(undefined, {
		month: "short",
		year: "numeric",
	});
}

/**
 * The period window a workflow extracts over.
 *
 * Both ends are nullable on the wire and an open end is a real answer, not a
 * missing one — "From Jan 2026" means every period after it, which is a
 * different instruction from a closed window and must not read as a blank.
 */
export function formatPeriodRange(
	from: string | null,
	to: string | null,
): string {
	const start = formatMonth(from);
	const end = formatMonth(to);
	if (start && end) return `${start} – ${end}`;
	if (start) return `From ${start}`;
	if (end) return `Up to ${end}`;
	return "Every period found";
}
